const POINTS = {
  MS: 374,
  MM: 472,
  TS: 616,
  TM: 808,
  TL: 1000,
  DS: 1190,
  DM: 1280
};
const BREAKPOINTS = Object.freeze(POINTS);
const BREAKPOINTS_KEYS = Object.keys(POINTS);
const BREAKPOINTS_MAX_MEDIA = Object.freeze(BREAKPOINTS_KEYS.reduce(function (result, name) {
  result[name] = `(max-width: ${BREAKPOINTS[name]}px)`;
  return result;
}, {}));
const BREAKPOINTS_MIN_MEDIA = Object.freeze(BREAKPOINTS_KEYS.reduce(function (result, name) {
  result[name] = `(min-width: ${BREAKPOINTS[name] + 1}px)`;
  return result;
}, {}));
export { BREAKPOINTS, BREAKPOINTS_KEYS, BREAKPOINTS_MAX_MEDIA, BREAKPOINTS_MIN_MEDIA };
